// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import * as serviceWorker from './serviceWorker';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';

// import store from './store1';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render (
//     <Provider store={store}>
//         <BrowserRouter>
//             <App />
//         </BrowserRouter>
//     </Provider>
// );

// serviceWorker.unregister();

// src/index.js
import React, { useState, useMemo, createContext, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import '../src/assets/css/eventflow.css';
import store from './store';
import router from './router';

// ← Import the two themes you defined in src/theme.js
import { lightTheme, darkTheme } from './theme';

// ← Export this so that Navbar (and any other component) can grab
//    `mode` and `toggleColorMode` via React.useContext.
export const ColorModeContext = createContext({
  mode: 'light',
  toggleColorMode: () => {},
});

const root = ReactDOM.createRoot(document.getElementById('root'));

function Root() {
  // 1) track current mode
  const [mode, setMode] = useState(
    () => localStorage.getItem('appThemeMode') || 'light'
  );

  useEffect(() => {
    localStorage.setItem('appThemeMode', mode);
    document.documentElement.setAttribute('data-bs-theme', mode);
    document.body.classList.remove('theme-light', 'theme-dark');
    document.body.classList.add(mode === 'dark' ? 'theme-dark' : 'theme-light');
  }, [mode]);

  // 2) memoize a toggle function so context value is stable
  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () =>
        setMode((prev) => (prev === 'light' ? 'dark' : 'light')),
    }),
    [mode]
  );

  // 3) pick the theme object based on mode
  const theme = useMemo(
    () => (mode === 'light' ? lightTheme : darkTheme),
    [mode]
  );

  return (
    <Provider store={store}>
      {/* make mode & toggle available */}
      <ColorModeContext.Provider value={colorMode}>
        {/* apply MUI theme */}
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </ColorModeContext.Provider>
    </Provider>
  );
}

root.render(<Root />);
